import type { CreateLitterInput } from '@gql/graphql';
import type { MtLitterPageFormValues } from '@presentation/pages';
import { useCallback } from 'react';

export const useLitterCreateBuilder = () => {
  const litterCreateBuilder = useCallback((values: Partial<MtLitterPageFormValues>) => {
    const litterData: CreateLitterInput = {
      // General
      price: values.price,
      priceFrom: values.priceFrom,
      priceTo: values.priceTo,
      fixedPrice: values.fixedPrice,
      birthday: values.birthday?.toISOString(),
      availabilityDate: values.availabilityDate?.toISOString(),
      description: values.description,
      dogBreedId: values.breedId!,
      malesLeftCount: values.malesLeftCount,
      femalesLeftCount: values.femalesLeftCount,
      fatherParentId: values.FATHER,
      motherParentId: values.MOTHER,

      malesCount: values.malesCount,
      femalesCount: values.femalesCount,
      microchipped: values.microchipped,
      vaccinated: values.vaccinated,
      vaccinationDate: values.vaccinationDate?.toISOString(),
      pedigree: values.pedigree,
      dewormed: values.dewormed,
      born: values.born,

      litterCode: values.litterCode,
    };

    return { litterData };
  }, []);

  return { litterCreateBuilder };
};
